// extracted by mini-css-extract-plugin
export default {"txfaq":"FAQ_txfaq__4zn8B"};